<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import userMain from "@/pages/system/user/user-main.vue"
export default {
  components: {
    userMain
  },
  name: "character",
  data() {
    return {
      tabData: [
        {
          name: "用户管理",
          key: "user",
          comp: userMain,
          status: "0",
        }
      ],
      tabCur: "user"
    }
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"

    })
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/system/user/user.vue